var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.thumb)?_c('div',{staticClass:"ui image"},[_c('img',{attrs:{"src":_vm.thumb}})]):_c('sui-icon',{attrs:{"size":_vm.size,"name":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }